import { FiX } from "react-icons/fi";
import { LicenseDetailsData } from "components/layout/Header/domain/types";
import ProcessHubLogo from "components/shared/ProgressMonitoringLogo";
import sdaia_logo from "assets/sdaia_logo.png";

const LicenseDetails = ({ setShowLicenseDetails, licenseData }: { setShowLicenseDetails: React.Dispatch<React.SetStateAction<boolean>>; licenseData: LicenseDetailsData[] }) => {

  return (
    <div
      className="absolute overflow-hidden left-0 top-0 w-screen z-50 h-screen bg-dark/65 flex items-center justify-center align-middle"
      onClick={(e) => {
        e.stopPropagation();
        setShowLicenseDetails(false);
      }}
    >
      <div className="w-[65%] h-[82%] rounded z-50 mt-20 flex flex-wrap mx-auto my-auto relative bg-midnight p-10" onClick={(e) => e.stopPropagation()}>
        <h1 className="text-xl 2xl:text-2xl font-bold w-full h-in">License Details</h1>
        <div className="p-2 h-max w-full border border-green">
          <div className="w-full rounded-lg">
            <div className="flex justify-between">
              <table className="w-full border-collapse max-w-xl">
                <tbody>
                  {licenseData.map((item, index) => (
                    <tr key={index}>
                      <td className="2xl:py-4 pr-4 font-semibold text-orange text-sm 2xl:text-lg">
                        {item.field}:
                      </td>
                      <td className="py-2 text-lg font-bold">{item.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="flex flex-col items-center gap-8 flex-1 justify-center">
                <img src={sdaia_logo} className="h-24 object-contain" />
                <div className="w-max">
                  <ProcessHubLogo variant="big" />
                </div>
              </div>
            </div>
            <div className="text-xs 2xl:text-sm">
              This certificate affirms that Saudi Data & AI Authority (SDAIA) is granted a valid and perpetual license to utilize the above mentioned software product, subject to the terms and conditions set forth in the End User License Agreement (EULA) provided by Takamul Smart Technology.
              The software shall not be copied, transferred, sublicensed, or distributed to any third party, nor shall it be modified, reverse engineered, or integrated with external systems without prior written consent from Takamul Smart Technology. Continued use of the software shall constitute acknowledgment and acceptance of the EULA, and any breach of its provisions may result in the immediate suspension or termination of the license.
            </div>
          </div>
        </div>
        <button
          className="cursor-pointer bg-blue rounded-md p-1 h-min absolute top-3 right-6"
          onClick={() => setShowLicenseDetails(false)}
        >
          <FiX size={20} />
        </button>
      </div>
    </div >
  );
};

export default LicenseDetails;